// extracted by mini-css-extract-plugin
module.exports = {"Brokers":"Brokers__Brokers__24Mrq"};